import {
    HideLoginModal,HideLogin2Modal, LOGIN, LOGOUT, ShowLoginModal,ShowLogin2Modal,REGISTER,CLEAR_REGISTER,CartUpdatedTrue,CartUpdatedFalse, MultipleAdded, MultipleAddedOff,SidePriceUpdate , SideDiscountedPrice
} from "../Actions/types";

const user = JSON.parse(localStorage.getItem("user"));
const mainCart = JSON.parse(localStorage.getItem("cart"));
// console.log(`mainCart`, mainCart);
// console.log(`user`, user);
const initialState = user
    ? {isLoggedIn: true,isRegistered: false, user, showLogin: false, showLogin2: false, cartUpdated: false, multipleAdded: false, mainCart:mainCart || {}, sideCartPrice:0 , SideDiscountedPrice : 0}
    : {isLoggedIn: false,isRegistered: false, user: null, showLogin: false, showLogin2: false, cartUpdated: false, multipleAdded: false, mainCart:mainCart || {}, sideCartPrice:0 , SideDiscountedPrice: 0};


export default function auth(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case LOGIN:
            return {
                ...state,
                isLoggedIn: true,
                user: payload.user,
            };
        case REGISTER:
            return {
                ...state,
                isLoggedIn: true,
                isRegistered: true,
                user: payload.user,
            };
        case CLEAR_REGISTER:
            return {
                ...state,
                isRegistered: false
            };
        case LOGOUT:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        case ShowLoginModal:
            return {
                ...state,
                showLogin: true
            };
        case HideLoginModal:
            return {
                ...state,
                showLogin: false
            };
        case ShowLogin2Modal:
            return {
                ...state,
                showLogin2: true
            };
        case HideLogin2Modal:
            return {
                ...state,
                showLogin2: false
            };
        case MultipleAdded:
            return {
                ...state,
                multipleAdded: true
            };
        case MultipleAddedOff:
            return {
                ...state,
                multipleAdded: false
            };
        case SidePriceUpdate:
            return {
                ...state,
                sideCartPrice: payload.sideCartPrice
               
            };
            case SideDiscountedPrice:
                return {
                    ...state,
                    SideDiscountedPrice: payload.SideDiscountedPrice
                   
                };
        case CartUpdatedTrue:
            return {
                ...state,
                cartUpdated: true,
                mainCart: payload.mainCart,
            };
        case CartUpdatedFalse:
            return {
                ...state,
                cartUpdated: false
            };
        default:
            return state;
    }
}

